export enum JsonTokenKind {
	KEY = 'key',
	STRING = 'string',
	NUMBER = 'number',
	KEYWORD = 'keyword',
	PUNCTUATION = 'punctuation',
	PLAIN = 'plain',
}
